import React from 'react';
import { Stack, FormLabel, Flex } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import MaskedInput from 'react-text-mask';
import SearchCNPJButton from './SearchCNPJButton';

const CNPJField = ({ 
  index, 
  control, 
  field, 
  cnpjControl, 
  isLoading, 
  onSearch, 
  onClear
}) => {
  const isFieldControlled = cnpjControl.includes(index);
  const isNewField = field?.newField;
  
  return (
    <Flex gap='16px' align='end'>
      <Stack w='400px' spacing='8px'>
        <FormLabel
          htmlFor={`form.${index}.cnpj`}
          fontSize='12px'
          lineHeight='normal'
          mb='0'
        >
          CNPJ da empresa
        </FormLabel>
        <Controller
          name={`form.${index}.cnpj`}
          control={control}
          render={({ field: inputField }) => (
            <MaskedInput
              id={`form.${index}.cnpj`}
              mask={[
                /\d/, /\d/, '.',
                /\d/, /\d/, /\d/, '.',
                /\d/, /\d/, /\d/, '/',
                /\d/, /\d/, /\d/, /\d/, '-',
                /\d/, /\d/
              ]}
              placeholder='___.___.___/____-__'
              value={inputField.value}
              onChange={inputField.onChange}
              disabled={!isNewField || isFieldControlled || isLoading}
              className='cnpj-field'
            />
          )}
        />
      </Stack>

      {isNewField && (
        <SearchCNPJButton
          index={index}
          control={control}
          isLoading={isLoading}
          isValid={isFieldControlled}
          onClick={isFieldControlled ? onClear : onSearch}
        />
      )}
    </Flex>
  );
};

export default CNPJField;